/**
 * RickyMartini × 綠界 C2C 門市選擇器。
 * 門市 query 不作為可信資料；只接受 Worker 簽發的 selection token，並由 Worker 反查。
 */
(function () {
  function init() {
    var root = document.querySelector('.cvs-picker');
    if (!root || root.dataset.cvsInit) return;
    root.dataset.cvsInit = '1';

    var endpoint = root.getAttribute('data-cvs-endpoint');
    var cartForm = document.getElementById('cart');
    var button = root.querySelector('.cvs-picker__btn');
    var select = root.querySelector('.cvs-picker__subtype');
    var status = root.querySelector('.cvs-picker__hint');
    var phoneInput = root.querySelector('.cvs-picker__phone-input');
    var phoneError = root.querySelector('.cvs-picker__phone-error');
    var buttonDefaultText = button ? button.textContent : '選擇門市';
    var activePopup = null;
    var popupPoll = null;
    var workerOrigin = '';
    var phoneRevision = 0;
    var initialPhone = phoneInput ? normalizeTaiwanMobile(phoneInput.value) : null;
    var savedPhone = phoneInput && phoneInput.value === initialPhone ? initialPhone : null;
    var savingPhone = null;
    var allowCheckoutOnce = false;

    try {
      workerOrigin = new URL(endpoint).origin;
    } catch (error) {
      setStatus('門市服務設定錯誤，請稍後再試。', true);
    }

    function setStatus(message, isError) {
      if (!status) return;
      status.hidden = false;
      status.textContent = message;
      status.classList.toggle('cvs-picker__hint--error', !!isError);
    }

    function setPhoneError(message) {
      if (!phoneError) return;
      phoneError.hidden = !message;
      phoneError.textContent = message || '';
      if (phoneInput) phoneInput.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function normalizeTaiwanMobile(value) {
      var compact = String(value || '').replace(/[\s()-]/g, '');
      if (/^09\d{8}$/.test(compact)) return compact;
      if (/^\+?8869\d{8}$/.test(compact)) {
        return '0' + compact.replace(/^\+?886/, '');
      }
      return null;
    }

    function isCheckoutSubmit(event) {
      var submitter = event.submitter;
      if (!submitter) return true;
      return submitter.id === 'checkout' || submitter.name === 'checkout';
    }

    function continueToCheckout() {
      var currentPhone = phoneInput ? normalizeTaiwanMobile(phoneInput.value) : null;
      if (!hasTrustedStore()) {
        setStatus('門市資料尚未完成驗證，請重新選擇門市。', true);
        return;
      }
      if (!currentPhone || currentPhone !== savedPhone) {
        saveCurrentPhoneThenCheckout();
        return;
      }
      allowCheckoutOnce = true;
      var checkout = document.getElementById('checkout');
      if (cartForm.requestSubmit) {
        cartForm.requestSubmit(checkout || undefined);
      } else {
        cartForm.submit();
      }
    }

    function savePhone(phone, revision) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { cvs_receiver_phone: phone } })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart_phone_update_failed');
          return response.json();
        })
        .then(function (cart) {
          if (
            !cart ||
            !cart.attributes ||
            cart.attributes.cvs_receiver_phone !== phone
          ) {
            throw new Error('cart_phone_not_persisted');
          }
          if (revision !== phoneRevision || !phoneInput || normalizeTaiwanMobile(phoneInput.value) !== phone) {
            return false;
          }
          savedPhone = phone;
          phoneInput.value = phone;
          return true;
        });
    }

    function saveCurrentPhoneThenCheckout() {
      var phone = phoneInput ? normalizeTaiwanMobile(phoneInput.value) : null;
      if (!phone) {
        setPhoneError('請輸入台灣手機號碼，例如 0912345678。');
        if (phoneInput) phoneInput.focus();
        return;
      }
      setPhoneError('');
      if (phone === savedPhone) {
        continueToCheckout();
        return;
      }

      function persistLatestPhone() {
        var latestPhone = phoneInput ? normalizeTaiwanMobile(phoneInput.value) : null;
        if (!latestPhone) throw new Error('invalid_phone');
        var revision = phoneRevision;
        setStatus('正在儲存取貨手機號碼…', false);
        return savePhone(latestPhone, revision).then(function (saved) {
          return saved ? true : persistLatestPhone();
        });
      }

      savingPhone = persistLatestPhone()
        .then(function (saved) {
          if (status) status.hidden = true;
          continueToCheckout();
        })
        .catch(function (error) {
          setPhoneError(
            error && error.message === 'invalid_phone'
              ? '請輸入台灣手機號碼，例如 0912345678。'
              : '手機號碼暫時無法儲存，請稍後再試。'
          );
        })
        .finally(function () {
          savingPhone = null;
        });
    }

    function hasTrustedStore() {
      return !!(
        root.getAttribute('data-store-id') &&
        root.getAttribute('data-selection-token')
      );
    }

    function resetButton() {
      if (!button) return;
      button.disabled = false;
      button.textContent = buttonDefaultText;
    }

    function stopPopupTracking(closePopup) {
      var popup = activePopup;
      activePopup = null;
      if (popupPoll) {
        window.clearInterval(popupPoll);
        popupPoll = null;
      }
      if (closePopup && popup && !popup.closed) {
        try {
          popup.close();
        } catch (error) {
          // Cross-origin popup may already be closing; no further action needed.
        }
      }
      resetButton();
    }

    function verifyAndSaveSelection(selectionToken) {
      // 每次都重新向 Worker 驗證；過期或偽造 token 不可直接放行結帳。
      root.removeAttribute('data-store-id');
      setStatus('正在驗證門市資料…', false);
      return fetch(
        endpoint +
          '/api/cvs-map/selection?token=' +
          encodeURIComponent(selectionToken),
        { headers: { Accept: 'application/json' } }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('selection_not_found');
          return response.json();
        })
        .then(function (selection) {
          if (!selection.storeId || !selection.subType) {
            throw new Error('invalid_selection');
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              attributes: {
                cvs_selection_token: selectionToken,
                cvs_store_id: selection.storeId,
                cvs_store_name: selection.storeName || '',
                cvs_sub_type: selection.subType,
                cvs_store_address: selection.storeAddress || ''
              }
            })
          }).then(function (response) {
            if (!response.ok) throw new Error('cart_update_failed');
            return selection;
          });
        })
        .then(function (selection) {
          var name = root.querySelector('.cvs-picker__name');
          var id = root.querySelector('.cvs-picker__id');
          var selected = root.querySelector('.cvs-picker__selected');
          if (name) name.textContent = selection.storeName || '';
          if (id) id.textContent = '（' + selection.storeId + '）';
          if (selected) selected.hidden = false;
          if (status) status.hidden = true;
          root.setAttribute('data-store-id', selection.storeId);
          root.setAttribute('data-selection-token', selectionToken);
          if (select) select.value = selection.subType;
          return selection;
        })
        .catch(function () {
          root.removeAttribute('data-store-id');
          root.removeAttribute('data-selection-token');
          setStatus('門市資料驗證失敗，請重新選擇門市。', true);
          return null;
        });
    }

    if (button && select) {
      button.addEventListener('click', function () {
        if (!workerOrigin) {
          setStatus('門市服務設定錯誤，請稍後再試。', true);
          return;
        }
        button.disabled = true;
        button.textContent = '等待門市選擇…';
        var subType = select.value || 'UNIMARTC2C';
        var popupUrl =
          endpoint +
          '/api/cvs-map/redirect?sub_type=' +
          encodeURIComponent(subType) +
          '&return_mode=popup&return_origin=' +
          encodeURIComponent(window.location.origin);
        var popup = window.open(
          popupUrl,
          'rickymartini_ecpay_cvs',
          'popup,width=800,height=720,resizable=yes,scrollbars=yes'
        );
        if (!popup) {
          resetButton();
          setStatus('瀏覽器阻擋了彈出式視窗，請允許後再重新選擇門市。', true);
          return;
        }

        activePopup = popup;
        try {
          popup.focus();
        } catch (error) {
          // Focusing is optional; the selection flow can continue without it.
        }
        popupPoll = window.setInterval(function () {
          if (!activePopup || !activePopup.closed) return;
          stopPopupTracking(false);
          setStatus('門市選擇視窗已關閉，尚未更新門市。', true);
        }, 500);
      });
    }

    window.addEventListener('message', function (event) {
      if (!activePopup || event.source !== activePopup || event.origin !== workerOrigin) {
        return;
      }
      var data = event.data;
      if (
        !data ||
        data.type !== 'ecpay_cvs_selected' ||
        typeof data.selectionToken !== 'string' ||
        data.selectionToken.length < 20 ||
        data.selectionToken.length > 256
      ) {
        return;
      }

      var selectionToken = data.selectionToken;
      stopPopupTracking(true);
      verifyAndSaveSelection(selectionToken);
    });

    if (cartForm) {
      cartForm.addEventListener('submit', function (event) {
        if (!isCheckoutSubmit(event)) return;
        if (allowCheckoutOnce) {
          allowCheckoutOnce = false;
          return;
        }
        event.preventDefault();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        if (!hasTrustedStore()) {
          setStatus('請先選擇超商取貨門市，再前往結帳。', true);
          try {
            root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (error) {
            root.scrollIntoView();
          }
          return;
        }
        if (savingPhone) return;
        saveCurrentPhoneThenCheckout();
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        phoneRevision += 1;
        phoneInput.setCustomValidity('');
        setPhoneError('');
      });
      phoneInput.addEventListener('invalid', function () {
        var message = '請輸入台灣手機號碼，例如 0912345678。';
        phoneInput.setCustomValidity(message);
        setPhoneError(message);
      });
    }

    var query = new URLSearchParams(window.location.search);
    var queryToken = query.get('cvs_selection_token');
    var selectionToken = queryToken || root.getAttribute('data-selection-token');
    if (!selectionToken) return;

    verifyAndSaveSelection(selectionToken)
      .finally(function () {
        if (queryToken) {
          var cleanUrl = window.location.pathname + window.location.hash;
          window.history.replaceState({}, '', cleanUrl);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
